<form class="edit-modal kw-dialog" (ngSubmit)="submit()" name="assemblyInputForm" #assemblyInputForm="ngForm">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">{{this.assembly.id ? 'Update' : 'New'}} Assembly</h2>
      <div class="modal-subtitle">{{this.assembly.id ? this.assembly.name : 'Fields marked * are required'}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="cancel()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading">
    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faFlask" class="section-icon"></fa-icon>
        <h3>Assembly</h3>
      </div>
      <div class="section-grid">
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input [(ngModel)]="this.assembly.name" matInput type="text" name="assemblyName">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Created {{"Product" | tenantWords}}</mat-label>
          <mat-select name="createdItem" [(ngModel)]="this.assembly.itemId">
            <mat-option *ngFor="let item of this.items" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Medium distinguished by</mat-label>
          <input [(ngModel)]="this.assembly.description" matInput type="text" name="assemblyDescription">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Est. Completed Quantity</mat-label>
          <input [(ngModel)]="this.assembly.estCompletedQuantity" matInput type="number" min="0" name="assemblyQty">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-row">
          <mat-label>Instructions</mat-label>
          <textarea [(ngModel)]="this.assembly.instructions" matInput rows="2"
            name="assemblyInstructions"></textarea>
        </mat-form-field>
      </div>
    </section>

    <section class="form-section" *ngIf="this.assembly.attributeValues.length">
      <div class="section-head">
        <fa-icon [icon]="faSliders" class="section-icon"></fa-icon>
        <h3>Attributes</h3>
      </div>
      <div class="section-grid">
        <ng-container *ngFor="let field of this.assembly.attributeValues">
          <mat-form-field *ngIf="getFieldOptions(field).length; else freeText" appearance="outline">
            <mat-label>{{field.name}}</mat-label>
            <mat-select required name="attr{{field.inventoryItemAssemblyAttributeId}}" [(ngModel)]="field.value">
              <mat-option *ngFor="let option of getFieldOptions(field)" [value]="option.value">
                {{option.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <ng-template #freeText>
            <mat-form-field appearance="outline">
              <mat-label>{{field.name}}</mat-label>
              <input [(ngModel)]="field.value" required matInput [type]="field.datatype == 'number' ? 'number' : 'text'"
                name="attr{{field.inventoryItemAssemblyAttributeId}}">
            </mat-form-field>
          </ng-template>
        </ng-container>
      </div>
    </section>

    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faLayerGroup" class="section-icon"></fa-icon>
        <h3>Constituents</h3>
        <span class="count-pill">{{this.assembly.components.length}}</span>
      </div>

      <div class="component-list" *ngIf="this.assembly.components.length; else noComponents">
        <div class="component-row" *ngFor="let component of this.assembly.components; trackBy: trackByComponent">
          <div class="component-main">
            <div class="component-name">
              {{component.item?.name}}
              <span *ngIf="component.isRequired" class="type-pill">Required</span>
            </div>
            <div class="component-sub">
              <span>Conc. {{component.unitQuantity ?? '—'}} /L</span>
              <span>Add {{component.quantityRequired ?? '—'}}</span>
              <span *ngIf="component.notes">{{component.notes}}</span>
            </div>
          </div>
          <button mat-icon-button type="button" class="remove-btn" aria-label="Remove constituent"
            (click)="removeComponent(component)">
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        </div>
      </div>
      <ng-template #noComponents>
        <div class="modal-empty">No constituents yet</div>
      </ng-template>

      <div class="add-component">
        <div class="section-grid cols-4">
          <mat-form-field appearance="outline" class="span-2">
            <mat-label>Constituent</mat-label>
            <mat-select name="componentItem" [(ngModel)]="this.currentComponent.item">
              <mat-option *ngFor="let item of this.constituentItems" [value]="item">
                {{item.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Conc. (_/L)</mat-label>
            <input [(ngModel)]="this.currentComponent.unitQuantity" matInput type="number" min="0" name="componentConc">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Amount to Add</mat-label>
            <input [(ngModel)]="this.currentComponent.quantityRequired" matInput type="number" min="0" name="componentQty">
          </mat-form-field>

          <mat-form-field appearance="outline" class="span-2">
            <mat-label>Notes</mat-label>
            <input [(ngModel)]="this.currentComponent.notes" matInput type="text" name="componentNotes">
          </mat-form-field>

          <mat-checkbox name="componentRequired" color="primary" class="required-check"
            [(ngModel)]="this.currentComponent.isRequired">Required</mat-checkbox>

          <button mat-stroked-button type="button" class="add-btn" [disabled]="!this.canAddComponent" (click)="addComponent()">
            <fa-icon [icon]="faPlus" class="me-2"></fa-icon>Add
          </button>
        </div>
      </div>
    </section>
  </div>

  <div class="modal-footer">
    <button *ngIf="this.assembly.id" mat-stroked-button class="danger-btn" type="button" (click)="deleteAssembly()">
      <fa-icon [icon]="faTrash" class="me-2"></fa-icon>Delete
    </button>
    <span class="footer-spacer"></span>
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="assemblyInputForm.invalid || this.isLoading">
      <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save
    </button>
  </div>

</form>
